import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from '@lp/services/language';
import { ThemeService } from '@lp/services/theme';
import { AuthService } from '@lp/services/auth';

@Component({
  selector: 'lp-root',
  templateUrl: 'app.component.html',
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _language = inject(LanguageService);
  private _theme = inject(ThemeService);
  private _auth = inject(AuthService);

  public isIframe = signal(false);

  constructor() {
    this._theme.init();
    this._language.init();
    this._auth.init(this._destroyRef);
  }

  public ngOnInit(): void {
    this.isIframe.set(window !== window.parent && !window.opener);
  }
}
